const JobFilter = ({
  section,
  setFilterJobs,
  setPaginationOptions,
  sortDate,
  setSortDate,
  title,
  setTitle,
  work,
  setWork,
  city,
  setCity,
}) => {
  const SortByDate = (data, type) => {
    if (type === 'OLDEST') {
      data?.sort(
        (a, b) => new Date(a?.issuedate?._text) - new Date(b?.issuedate?._text)
      );
      return data;
    } else {
      data?.sort(
        (a, b) => new Date(b?.issuedate?._text) - new Date(a?.issuedate?._text)
      );
      return data;
    }
  };

  const Filter = async (city, title, work, sortType) => {
    let result;
    if (city === '' && work === '' && title === '') {
      let data;
      data = SortByDate(section, sortType);
      setFilterJobs(data);
      setPaginationOptions(prev => {
        return { ...prev, page: 1 };
      });
    } else if (title === '' && work !== '' && city === '') {
      result = section?.filter(item =>
        item?.positiontype?._text?.toUpperCase().includes(work)
      );
      if (result) {
        let data;
        data = SortByDate(result, sortType);
        setFilterJobs(data);
        setPaginationOptions(prev => {
          return { ...prev, page: 1 };
        });
      } else {
        setFilterJobs([]);
      }
    } else if (work === '' && title === '' && city !== '') {
      result = section?.filter(
        item =>
          item?.state?._text?.toUpperCase().includes(city) ||
          item?.city?._text?.toUpperCase().includes(city) ||
          item?.countryid?._text
            ?.toUpperCase()
            .includes(city === 'UNITED STATES' ? 'US' : city)
      );
      if (result) {
        let data;
        data = SortByDate(result, sortType);
        setFilterJobs(data);
        setPaginationOptions(prev => {
          return { ...prev, page: 1 };
        });
      } else {
        setFilterJobs([]);
      }
    } else if (work === '' && city === '' && title !== '') {
      result = section?.filter(item =>
        item?.title?._cdata?.toUpperCase().includes(title)
      );
      if (result) {
        let data;
        data = SortByDate(result, sortType);
        setFilterJobs(data);
        setPaginationOptions(prev => {
          return { ...prev, page: 1 };
        });
      } else {
        setFilterJobs([]);
      }
    } else if (work === '' && title !== '' && city !== '') {
      result = section?.filter(
        item =>
          (item?.state?._text?.toUpperCase().includes(city) ||
            item?.city?._text?.toUpperCase().includes(city) ||
            item?.countryid?._text
              ?.toUpperCase()
              .includes(city === 'UNITED STATES' ? 'US' : city)) &&
          item?.title?._cdata?.toUpperCase().includes(title)
      );
      if (result) {
        let data;
        data = SortByDate(result, sortType);
        setFilterJobs(data);
        setPaginationOptions(prev => {
          return { ...prev, page: 1 };
        });
      } else {
        setFilterJobs([]);
      }
    } else if (work !== '' && title === '' && city !== '') {
      result = section?.filter(
        item =>
          (item?.state?._text?.toUpperCase().includes(city) ||
            item?.city?._text?.toUpperCase().includes(city) ||
            item?.countryid?._text
              ?.toUpperCase()
              .includes(city === 'UNITED STATES' ? 'US' : city)) &&
          item?.positiontype?._text?.toUpperCase().includes(work)
      );
      if (result) {
        let data;
        data = SortByDate(result, sortType);
        setFilterJobs(data);
        setPaginationOptions(prev => {
          return { ...prev, page: 1 };
        });
      } else {
        setFilterJobs([]);
      }
    } else {
      result = section?.filter(
        item =>
          item?.title?._cdata?.toUpperCase().includes(title) &&
          item?.positiontype?._text?.toUpperCase().includes(work) &&
          (item?.state?._text?.toUpperCase().includes(city) ||
            item?.city?._text?.toUpperCase().includes(city) ||
            item?.countryid?._text
              ?.toUpperCase()
              .includes(city === 'UNITED STATES' ? 'US' : city))
      );
      if (result) {
        let data;
        data = SortByDate(result, sortType);
        setFilterJobs(data);
        setPaginationOptions(prev => {
          return { ...prev, page: 1 };
        });
      }
    }
  };
  return (
    <div className="py-6 px-6 bg-[#F7FAFF] rounded-[10px]">
      <div className="grid grid-cols-12 gap-5">
        <div className="lg:col-span-3 sm:col-span-6 col-span-12">
          <label
            htmlFor="skill"
            className="mb-2 block text-[18px] font-[600] text-[#2B2B2D] tracking-[-0.4px]"
          >
            Specializations:
          </label>
          <input
            onChange={async e => {
              setTitle(e.target.value.toUpperCase());
              Filter(city, e.target.value.toUpperCase(), work, sortDate);
            }}
            name="skill"
            id=""
            placeholder="Title, Skill"
            className="focus:outline-none placeholder:text-[#949494] h-[46px] focus:border-[#B8B8B8] focus:ring-[0px] text-[16px] text-[#949494] font-[400] w-[100%] bg-[#ffffff] border border-[#B8B8B8] rounded-[6px] px-3"
          />
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12">
          <label
            htmlFor="Work"
            className="mb-2 block text-[18px] font-[600] text-[#2B2B2D] tracking-[-0.4px]"
          >
            Work Type
          </label>
          <select
            name="Work"
            id=""
            onChange={async e => {
              setWork(e.target.value.toUpperCase());
              await Filter(city, title, e.target.value.toUpperCase(), sortDate);
            }}
            className="focus:outline-none focus:border-[#B8B8B8] focus:ring-[0px] text-[16px] text-[#949494] font-[400] w-[100%] bg-[#ffffff] border border-[#B8B8B8] rounded-[6px] px-3"
          >
            <option value="">All</option>
            <option value="Full Time">Full Time</option>
            <option value="Contract">Contract</option>
            <option value="Contract to Hire">Contract to Hire</option>
            <option value="Right to Hire">Right to Hire</option>
          </select>
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12">
          <label
            htmlFor=""
            className="mb-2 block text-[18px] font-[600] text-[#2B2B2D] tracking-[-0.4px]"
          >
            Locations
          </label>
          <input
            onChange={async e => {
              setCity(e.target.value.toUpperCase());
              await Filter(e.target.value.toUpperCase(), title, work, sortDate);
            }}
            placeholder="All Locations"
            name=""
            id=""
            className="focus:outline-none h-[46px] placeholder:text-[#949494] focus:border-[#B8B8B8] focus:ring-[0px] text-[16px] text-[#949494] font-[400] w-[100%] bg-[#ffffff] border border-[#B8B8B8] rounded-[6px] px-3"
          />
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12">
          <label
            htmlFor=""
            className="mb-2 block text-[18px] font-[600] text-[#2B2B2D] tracking-[-0.4px]"
          >
            Sort by
          </label>
          <select
            name=""
            onChange={e => {
              setSortDate(e.target.value);
              Filter(city, title, work, e.target.value);
            }}
            className="focus:outline-none focus:border-[#B8B8B8] focus:ring-[0px] text-[16px] text-[#949494] font-[400] w-[100%] bg-[#ffffff] border border-[#B8B8B8] rounded-[6px] px-3"
          >
            <option value="NEWEST">Date (Newest)</option>
            <option value="OLDEST">Date (Oldest)</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default JobFilter;
